import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';

const IssueFetchError = ({error}) => {
  if (!error) {
    return null;
  }

  const genericErrorMsg = i18n.t('global.genericError');
  return <div className="isui-error">{genericErrorMsg}</div>;
};

IssueFetchError.displayName = 'IssueFetchError';
IssueFetchError.propTypes = {
  error: PropTypes.bool
};

export default IssueFetchError;
